import { AuthModel, UserModel } from "../../models/authModel";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialFineState: AuthModel = {
  user: null,
  token: null,
  refreshToken: null,
  loading: false,
};

const authSlice = createSlice({
  name: "fine",
  initialState: initialFineState,
  reducers: {
    setAuthLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setUser(state, action: PayloadAction<UserModel | null>) {
      state.user = action.payload;
    },
    setToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
    },
    setRefreshToken(state, action: PayloadAction<string | null>) {
      state.refreshToken = action.payload;
    },
    setUserEmail(state, action: PayloadAction<string>) {
      state.user!.email = action.payload;
    },
    setUserMobileNumber(state, action: PayloadAction<string>) {
      state.user!.mobile_number = action.payload;
    },
  },
});
export default authSlice;
